//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  props: {
    footerType: {
      type: String,
      required: true
    },
    hideScrollToTop: {
      type: Boolean,
      required: true
    },
    navbarType: {
      type: String,
      required: true
    },
    navbarColor: {
      type: String,
      required: true,
      default: '#fff'
    },
    routerTransition: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      active: false,
      customPrimaryColor: '#3DC9B3',
      customNavbarColor: '#3DC9B3',
      routerTransitionsList: [{
        text: 'Zoom Fade',
        value: 'zoom-fade'
      }, {
        text: 'Slide Fade',
        value: 'slide-fade'
      }, {
        text: 'Fade Bottom',
        value: 'fade-bottom'
      }, {
        text: 'Fade',
        value: 'fade'
      }, {
        text: 'Zoom Out',
        value: 'zoom-out'
      }, {
        text: 'None',
        value: 'none'
      }],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
    };
  },
  watch: {
    layoutType: function layoutType(val) {
      // Reset unsupported options
      if (val === 'horizontal') {
        this.themeMode === 'semi-dark' ? this.themeMode = 'light' : null;
        this.navbarType === 'hidden' ? this.navbarTypeLocal = 'floating' : null;
        this.$emit('updateNavbarColor', '#fff');
      }
    }
  },
  computed: {
    footerTypeLocal: {
      get: function get() {
        return this.footerType;
      },
      set: function set(val) {
        this.$emit('updateFooter', val);
      }
    },
    hideScrollToTopLocal: {
      get: function get() {
        return this.hideScrollToTop;
      },
      set: function set(val) {
        this.$emit('toggleHideScrollToTop', val);
      }
    },
    navbarColorInitial: function navbarColorInitial() {
      return this.$store.state.theme === 'dark' ? '#10163a' : '#fff';
    },
    navbarColorOptionClasses: function navbarColorOptionClasses() {
      var _this = this;

      return function (color) {
        var classes = {};
        if (color == _this.navbarColorLocal) classes['shadow-outline'] = true;
        if (_this.navbarTypeLocal == 'static') classes['cursor-not-allowed'] = true;
        return classes;
      };
    },
    navbarColorLocal: {
      get: function get() {
        return this.navbarColor;
      },
      set: function set(val) {
        if (this.navbarType == 'static') return;
        this.$emit('updateNavbarColor', val);
      }
    },
    navbarTypeLocal: {
      get: function get() {
        return this.navbarType;
      },
      set: function set(val) {
        this.$emit('updateNavbar', val);
      }
    },
    layoutType: {
      get: function get() {
        return this.$store.state.mainLayoutType;
      },
      set: function set(val) {
        this.$store.commit('UPDATE_MAIN_LAYOUT_TYPE', val);
      }
    },
    primaryColor: {
      get: function get() {
        return this.$store.state.themePrimaryColor;
      },
      set: function set(val) {
        this.$store.commit('UPDATE_PRIMARY_COLOR', val);
      }
    },
    reducedSidebar: {
      get: function get() {
        return this.$store.state.reduceButton;
      },
      set: function set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val);
      }
    },
    routerTransitionLocal: {
      get: function get() {
        return this.routerTransition;
      },
      set: function set(val) {
        this.$emit('updateRouterTransition', val);
      }
    },
    rtl: {
      get: function get() {
        return this.$vs.rtl;
      },
      set: function set(val) {
        this.$vs.rtl = val;
      }
    },
    themeMode: {
      get: function get() {
        return this.$store.state.theme;
      },
      set: function set(val) {
        this.$store.dispatch('updateTheme', val);
      }
    },
    windowWidth: function windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    updatePrimaryColor: function updatePrimaryColor(color) {
      this.primaryColor = color;
      this.$vs.theme({
        primary: color
      });
    }
  },
  components: {
    VuePerfectScrollbar: VuePerfectScrollbar
  }
};